import React, { useEffect, useMemo } from "react";
import { Container } from "reactstrap";
import BreadCrumb from "Components/Common/BreadCrumb";
import { useSelector, useDispatch } from "react-redux";
import { createSelector } from "reselect";

import { getContract as onGetContract } from "../../../slices/thunks";
import { useParams, useLocation } from "react-router-dom";
import { isContractActive } from "common/lib/contractOptions";
import { LEVEL_AGENCY } from "common/constants";
import ContractContent from "pages/Contracts/ViewContract/ContractContent";
import { usePageActivity } from "Components/Hooks/UsePageActivity";

const ViewAgencyContract = () => {
  const location = useLocation();
  const dispatch: any = useDispatch();

  const { id: contractId } = useParams();
  usePageActivity(location.pathname, "View Agency Contract", contractId);

  useEffect(() => {
    dispatch(
      onGetContract({
        level: LEVEL_AGENCY,
        id: contractId,
      })
    );
  }, [contractId, dispatch]);

  const selectLayoutState = (state: any) => state.Contracts;
  const selectProperties = createSelector(selectLayoutState, (state) => ({
    contract: state.contract,
  }));

  const { contract } = useSelector(selectProperties);

  document.title = "View Contract | CIMS";

  const status = useMemo(() => {
    return isContractActive(contract?.startDate, contract?.endDate);
  }, [contract.startDate, contract.endDate]);

  return (
    <div className="page-content">
      <Container fluid>
        <BreadCrumb title="View Contract" pageTitle="Contracts" />

        <ContractContent contract={contract} status={status} />
      </Container>
    </div>
  );
};

export default ViewAgencyContract;
